import { render, staticRenderFns } from "./employee.vue?vue&type=template&id=c05ab1ba&"
import script from "./employee.vue?vue&type=script&lang=js&"
export * from "./employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports